import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

// const ProjectList = lazy(() => import('../../container/borrower/project/projectList'));
const MemberList = lazy(() => import('../../container/borrower/member/memberList'));
// const MemberRegistration = lazy(() => import('../../container/borrower/member/memberRegistration'));
// const MemberUpdate = lazy(() => import('../../container/borrower/member/memberUpdate'));
// const MemberDetails = lazy(() => import('../../container/borrower/member/memberDetails/memberDetails'));

function ProjectRoute() {
  return (
    <Routes>
      {/* <Route path="registration" element={<ProjectRegistration />} /> */}
      <Route path="list" element={<MemberList />} />
      {/* <Route path="/update/:id" element={<ProjectUpdate />} /> */}
      {/* <Route path="detail/:id" element={<ProjectDetails />} /> */}
    </Routes>
  );
}

export default ProjectRoute;
